import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.6095 19.6798L14.8516 14.9219",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "square"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.6093 16.6795C13.923 16.6795 16.6092 13.9933 16.6092 10.6796C16.6092 7.36595 13.923 4.67969 10.6093 4.67969C7.29563 4.67969 4.60938 7.36595 4.60938 10.6796C4.60938 13.9933 7.29563 16.6795 10.6093 16.6795Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }